import React from 'react'
import { Navbar, Button, Container } from 'react-bootstrap';
import LogoImage from '../../assets/image/Logo.png'
import { Link } from 'react-router-dom';
import { getItem } from '../../config/localStorage';


function Header() {
  const AUTH_TOKEN = getItem("token");
  const POPPIN_JOB_BASE_URL = process.env.REACT_APP_POPPIN_JOB_BASE_URL;
  const LogOutApplication = () => {
    localStorage.clear();
    window.location.href = POPPIN_JOB_BASE_URL;
  }

  const LogInApplication = () => {
    localStorage.clear();
    window.location.href = POPPIN_JOB_BASE_URL + 'login';
  }

  const redirectPoppinJobHome = () => {
    window.location.href = POPPIN_JOB_BASE_URL;
  }

  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary navbar-outer responsive-header">
        <Container>
          <Navbar.Brand><Link to='/'><img src={LogoImage} /></Link></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">

            <div className='float-right d-flex gap-2 respo-header-btn-sec'>
              {
                AUTH_TOKEN ?
                  <>
                    <Button variant="outline-secondary" className='custom-btn-info' onClick={redirectPoppinJobHome} >Back to Poppin' Jobs</Button>
                    <Button className='btn button-green my-account-btn' onClick={LogOutApplication}>Logout</Button>
                  </>
                  :
                  <Button className='btn button-green my-account-btn' onClick={LogInApplication}>Login</Button>
              }
            </div>
          </Navbar.Collapse>

        </Container>

      </Navbar>
    </>
  )
}

export default Header
